import { render, staticRenderFns } from "./RequestCreatorServiceEmbroideryConfig.vue?vue&type=template&id=61fd8668&"
import script from "./RequestCreatorServiceEmbroideryConfig.vue?vue&type=script&lang=js&"
export * from "./RequestCreatorServiceEmbroideryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports